import Intro from './0-Intro';
import Remuneration from './A-Remuneration';
import Titrisation from './B-Titrisation';
import Titrisation2 from './B-Titrisation2';
import Toobig from './C-Toobig';
import Regulation from './D-Regulation';
import Oligarchie from './E-Oligarchie';

module.exports = {
    intro: Intro,
    remuneration: Remuneration,
    titrisation: Titrisation,
    titrisations: Titrisation2,
    toobig: Toobig,
    regulation: Regulation,
    oligarchie: Oligarchie,
};



// WEBPACK FOOTER //
// ./js/components/scenes/index.js